module.exports = __webpack_public_path__ + "img/IMG_2647.fab75c06.jpg";